import React, { useEffect, useState } from 'react'
import BlogCard from '../blogCard'

function RelatedBlogs(props) {
  const [postData, setPostData] = useState(null)
  console.log(props, 'propsss');

  useEffect(() => {
    if (Array.isArray(props.allBlogsList) && Array.isArray(props.blogDetail.fromCategory)) {
      calculateBlogToShow()
    }
  }, [props.blogDetail, props.allBlogsList])


  const checkContainsTag = (fromCategoryBlogs) => {
    const {mustContainTags} = props.blogDetail;  // blog mmust contains atleast 2 of mustContainsTags
    const {optionalContainTags} = props.blogDetail;

    console.log(fromCategoryBlogs,"fromcategory",mustContainTags, 'mustContainTags', optionalContainTags, 'optionalContainTags', fromCategoryBlogs);
    const filteredBlogList = [];
    fromCategoryBlogs.forEach((blog) => {
      let matchTag = 0;
      mustContainTags.forEach((tag) => {
        if (blog.tags.includes(tag)) matchTag++;
        console.log()
      })
      if (matchTag >= 2) {
        filteredBlogList.push(blog)
      }
    })

    if (filteredBlogList.length >= 4) {
      return filteredBlogList;
    }

    // console.log("mustContainTags = "+mustContainTags);
    // console.log("optionalContainTags = "+optionalContainTags);

    const optionalContainTags2=mustContainTags;
    optionalContainTags2.push(optionalContainTags);
        
    console.log(`optionalContainTags2 = ${optionalContainTags2}`);

    fromCategoryBlogs.forEach((blog) => {
      let matchTag = 0;
      optionalContainTags2.forEach((tag) => {
        if (blog.tags.includes(tag)) matchTag++;
      })
      if (matchTag >= 2) {
        filteredBlogList.push(blog)
      }
    })
    return filteredBlogList;
  }

  const calculateBlogToShow = () => {
    const blogList = props.allBlogsList;
    const {fromCategory} = props.blogDetail;
    const {mustContainTags} = props.blogDetail;
    const {optionalContainTags} = props.blogDetail;
    const fromCategoryBlogs = [];
    if (Array.isArray(blogList) && Array.isArray(fromCategory)) {
      blogList.forEach((blog) => {
        fromCategory.forEach((category) => {
          if (blog.categories[0].replaceAll(" ", "-").toLowerCase() == category.replaceAll(" ", "-").toLowerCase()) {
            fromCategoryBlogs.push(blog);
          }
        });
      });
    }
    let result = checkContainsTag(fromCategoryBlogs);
    result.sort((a, b) => new Date(b.date) - new Date(a.date));
        
    // result = arrUnique(result);

    const result1 = result.filter((thing, index, self) =>
      index === self.findIndex((t) => (
        JSON.stringify(t) === JSON.stringify(thing)
      ))
    )
    result=result1;

    setPostData(result.slice(0, 4));
  }

  // function arrUnique(arr) 
  // const arrUnique = (arr) => {
  //     var cleaned = [];
  //     arr.forEach(function(itm) {
  //         var unique = true;
  //         cleaned.forEach(function(itm2) {
  //             if (_.isEqual(itm, itm2)) unique = false;
  //         });
  //         if (unique)  cleaned.push(itm);
  //     });
  //     return cleaned;
  // }
    


  return (Array.isArray(postData) && postData.length >= 1 && <>
    <div className="more-text">More like this</div>
    <div className="blog-list-container">
      {postData && postData.map(blog => (
        <BlogCard blog={blog} hideDescMobile="true" />
      ))}
    </div></>
  )
}

export default RelatedBlogs
